export const TransactionSteps = () => {
  const StepsDatas = [
    {
      tracker: '1',
      title: 'Create Buy/Sell FX Offer',
    },
    {
      tracker: '2',
      title: 'Bid/Accept Offer',
    },
    {
      tracker: '3',
      title: 'Make Payment',
    },
    {
      tracker: '4',
      title: 'Complete transaction',
    },
  ];
  return (
    <div className='flex flex-col md:flex-row gap-6 w-full '>
      {StepsDatas.map((StepData) => {
        return (
          <div
            className='w-full flex flex-col gap-4 p-6 bg-p-wh drop-shadow-lg rounded'
            key={StepData.tracker}
          >
            <div className='w-fit h-fit px-4 py-2  bg-b-mc text-p-wh drop-shadow-md rounded flex justify-center items-center'>
              {StepData.tracker}
            </div>
            <div className='w-full pb-4'>
              <h2>{StepData.title}</h2>
            </div>
          </div>
        );
      })}
    </div>
  );
};
